module.exports = __webpack_public_path__ + "img/1654.0c2dca7b.jpg";